var loadAggregatedReviewsMapMarkers = function (markers) {
	jQuery(document).ready(function () {
		//The variables that will be used within the map configuration options.
		var aggregatedReviewsMap; //The variable for the main map itself
		var aggregatedReviewsMapCenter = new google.maps.LatLng(window.mapHeroLat, window.mapHeroLon); //The latitude and longitude of the center of the map.
		var aggregatedReviewsMapZoom = window.mapZoomLevel; //The degree to which the map is zoomed in. This can range from 0 (least zoomed) to 21 and above (most zoomed).
		var aggregatedReviewsMapZoomMin = 4; //The min zoom levels that is allowed.
		var aggregatedReviewsMapZoomMax = 16; //The min zoom levels that is allowed.
		var aggregatedReviewsMapIcon = '/assets/img/map-marker.png';

		//These options configure the setup of the map.
		var aggregatedReviewsMapOptions = {
			center: aggregatedReviewsMapCenter,
			zoom: aggregatedReviewsMapZoom,
			minZoom: aggregatedReviewsMapZoomMin,
			maxZoom: aggregatedReviewsMapZoomMax,
			icon: aggregatedReviewsMapIcon,
			panControl: false,
			mapTypeControl: false,
			scrollwheel: false
		};

		loadAggregatedReviewsMap(markers);

		//Function that loads the map.
		function loadAggregatedReviewsMap(markers) {
			aggregatedReviewsMap = new google.maps.Map(document.getElementById("map"), aggregatedReviewsMapOptions);

			var createdMarkers = [];

		    var style = 
		        [
		            {
		                url: '/assets/img/reviews/m3.png',
		                height: 66,
		                width: 66,
		                textColor: '#FFFFFF'
		            }
		        
		    ];

			if (markers) {
				for (var i = 0; i < markers.length; i++) {
					var rm = markers[i];
					var lat = parseFloat(rm.Latitude);
					var long = parseFloat(rm.Longitude);

					if (lat != NaN && long != NaN) {
						var markerLatLng = { lat: rm.Latitude, lng: rm.Longitude };
						var marker = new google.maps.Marker({
							position: markerLatLng,
							map: aggregatedReviewsMap,
							icon: aggregatedReviewsMapIcon
						});

						createdMarkers.push(marker);
					}
				}

			    var markerCluster = new MarkerClusterer(aggregatedReviewsMap,
			        createdMarkers,
			        {
			            styles: style,
			            imagePath: '/assets/img/reviews/m'
			        });
					
			}
		}
	});
}

module.exports = loadAggregatedReviewsMapMarkers;